import { CardModal } from '@mindly/ui-components';
import { useState } from 'react';
import { useAnalytics } from 'src/shared';
import { LanguageWorkInProgressWidget } from 'src/widgets/LanguageWorkInProgressWidget';

type LanguageWorkInProgressModalFeatureProps = {
  isOpen: boolean;
  closeModal: () => void;
  selectedLanguage: string | null;
} & React.ComponentProps<typeof CardModal>;

export const LanguageWorkInProgressModalFeature: React.FC<LanguageWorkInProgressModalFeatureProps> = ({
  isOpen,
  closeModal,
  selectedLanguage,
  ...modalProps
}) => {
  const { trackPredefinedEvent } = useAnalytics();
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);

  return (
    <CardModal
      {...modalProps}
      onDidDismiss={() => {
        setShowSuccessScreen(false);
        closeModal();
      }}
      isShowHandle={false}
      isOpen={isOpen}
      canDismiss={isOpen}
      isShowCloseButton={!showSuccessScreen}
      backButton={true}
    >
      <LanguageWorkInProgressWidget
        continueWithDefaultLanguageButtonClick={closeModal}
        saveEmailButtonClick={(email) => {
          trackPredefinedEvent('LOGIN_LANGUAGE_UNSUPPORTED_EMAIL_PROVIDED', { email: email });
          setShowSuccessScreen(true);
        }}
        showSuccessScreen={showSuccessScreen}
        selectedLanguage={selectedLanguage}
      />
    </CardModal>
  );
};
